<template>
  <div style="height:100vh; background-size: cover; background-position: top;" :style="{ backgroundImage: 'url(' + header_image + ')' }">
    <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div> 
    <div v-if="product" style="background-color: #e4e9f0; padding-bottom:30px">
      <header class="topbar bd-navbar clearfix" style="padding:5px; box-shadow: 0 2px 0px rgba(0, 0, 0, 0.16); !important; background-color: #17bab8; height:80px; margin-bottom:20px;">
        <div class="container">
          <div class="row" style="padding-right: 5px; padding-left: 5px;">
            <div class="col-md-12">
              <h1 style="font-weight:bold; color: #ffffff; margin-top: 15px; text-decoration: none;">Welcome to {{product.name}}</h1>
            </div>
          </div>
        </div>
      </header>
      
      <div class="container">
        <div v-if="!registered" class="row">
          <div class="col-sm-12">
            <h2 style="margin-bottom:20px;">Ciao {{form.first_name}} {{form.last_name}}, you are just a few click away...</h2>

            <h2>Please login with your Audio Modeling account credentials or register if you haven’t an account yet.</h2>
          </div>
          <div class="col-sm-12">
            <div class="row" style="margin-top:50px; text-align: center;">
              <div class="col-sm-6">
                <button class="btn-block btn btn-primary btn-lg" style="font-weight: bold; font-size: 24px; max-width:200px; border:2px solid #108180; margin-top:4px" v-on:click="register" v-if="!user.authenticated">Register</button>
                <h3>If you don’t have an Audio Modeling account</h3>
              </div>
              <div class="col-sm-6">
                <button v-on:click="login" v-if="!user.authenticated" class="btn-block btn btn-secondary btn-lg" style="font-weight: bold; font-size: 24px; max-width:200px; color:#108180; border:2px solid #108180;">Login</button>
                <h3>If you are already have an account</h3>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h1>Well done!<br>
          You can now install your {{product.name}} copy from the Audio Modeling 
          Software Center, that is the application that manages the installation of all 
          Audio Modeling products.</h1>
          <a href="https://audiomodeling.com/support/install-and-update/" class="btn-block btn btn-primary btn-lg" style="font-weight: bold; font-size: 24px; width:auto; border:2px solid #108180; margin-top:20px">Download Audio Modeling Software Center</a>
                <h3>if it’s the first time you install an Audio 
Modeling product</h3>
<a href="/" style="font-weight: bold; font-size: 24px; color:#108180; text-decoration: underline;"><h3 style="font-weight: bold;">or exit and go to the customer portal</h3></a>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
  import auth from '../auth'
  export default {
    data () {
      return {
        loading: false,
        user: auth.user,
        product: null,
        form: null,
        registered: false,
        header_image: null
      }
    },
    async beforeMount(){
      if(this.$route.params.token){
        //await auth.assignFreeProduct(this,this.$route.query.ref);
        localStorage.setItem('ref_token', this.$route.params.token)
      }
      await this.getProduct()
     
    },
    methods:{
      setData(){
        localStorage.setItem('ref_token', this.$route.params.token)
        localStorage.setItem('ref_first_name', this.form.first_name)
        localStorage.setItem('ref_last_name', this.form.last_name)
        localStorage.setItem('ref_email', this.form.email)
      },
      async getProduct() {
        await auth.getFreeProduct(this, this.$route.params.token)
        setTimeout(() => {
          if(auth.user.authenticated && auth.user.authenticated === true){
            auth.registerFreeProduct(this, this.$route.params.token)
            localStorage.setItem('ref_token', '')
            localStorage.setItem('ref_first_name', '')
            localStorage.setItem('ref_last_name', '')
            localStorage.setItem('ref_email', '')
          }
        }, 1000);
      },
      register(){
        this.setData()
        this.$router.push('/register')
      },
      login(){
        this.setData()
        this.$router.push('/login')
      }     
    }
  }
</script>
<style>
footer{display:none}
</style>


// WEBPACK FOOTER //
// src/components/Freeproduct.vue